<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Relatório</span>
        <h3 class="page-title d-inline">Orçamentos</h3>
        <d-button class="btn btn-primary text-white float-right mr-4" @click="exportCsv">Exportar csv</d-button>
      </div>
    </div>

    <div class="card mb-4">
      <div class="">
        <form @submit.prevent="searchReport" class="w-100 d-flex align-items-center">
          <d-col cols="10" class="form-group mb-0">
            <d-row>
              <d-col cols="3" class="form-group mt-2">
                <label for="period">Periodo</label>
                <between-dates :byPeriodStart.sync="filters.byPeriodStart" :byPeriodEnd.sync="filters.byPeriodEnd"/>
              </d-col>
              <d-col cols="2" class="form-group mt-2">
                <label for="period">Classificação</label>
                <select-filter :model.sync="filters.byRating" :options="options.rating"></select-filter>
              </d-col>
              <d-col cols="2" class="form-group mt-2">
                <label for="period">Status</label>
                <select-filter :model.sync="filters.byStatus" :options="options.status"></select-filter>
              </d-col>
              <d-col cols="2" class="form-group mt-2">
                <label for="period">Tipo</label>
                <select-filter :model.sync="filters.byType" :options="options.type"></select-filter>
              </d-col>
              <d-col cols="2" class="form-group mt-2">
                <label for="period">Vendedor</label>
                <select-filter :model.sync="filters.bySeller" :options="options.seller"></select-filter>
              </d-col>
            </d-row>
          </d-col>
          <d-col cols="2" class="form-group mb-0">
            <label class="submit">&nbsp;</label>
            <d-button class="btn mt-3" type="submit">Filtrar</d-button>
          </d-col>
        </form>
      </div>
    </div>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <div class="card card-small mb-4">
          <div class="card-header"></div>
          <div class="card-body p-0 pb-3">
            <div class="table-overflow">
              <report-quotation-table :reports="reports.list"></report-quotation-table>
            </div>
            <pagination :total-items="reports.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </div>
      </d-col>
    </d-row>

    <report-total :totals="reports.total"></report-total>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { catchPdf, downloadCsvFile } from '_utils';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import BetweenDates from '_shared/BetweenDates.vue';
import ReportService from '_services/rest/modules/report';
import ReportTotal from '../components/ReportTotal.vue';
import SelectFilter from '../components/SelectFilter.vue';
import ReportQuotationTable from '../components/ReportQuotationTable.vue';
import { TOTAL_ITEMS } from '../components/ReportModel';

export default {
  name: 'report-quotation-list',
  components: {
    Pagination,
    ReportTotal,
    BetweenDates,
    SelectFilter,
    ReportQuotationTable,
  },
  data() {
    return {
      filters: { byPeriodStart: null, byPeriodEnd: null },
      pagination: {
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    options() {
      const { reportFilters } = this.$store.state.report;
      if (reportFilters) {
        return reportFilters;
      }
      return [];
    },
    reports() {
      const { reportQuotationList } = this.$store.state.report;
      if (reportQuotationList && reportQuotationList.list) {
        return reportQuotationList;
      }
      return {
        list: [],
        total: TOTAL_ITEMS,
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'getReportFilters',
      'getReportQuotationList',
    ]),
    exportCsv() {
      ReportService.exportReportQuotationCsv(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }));
    },
    getList() {
      this.getReportQuotationList(this.pagination);
    },
    getOptions() {
      if (!this.$store.state.report.reportFilters) {
        this.getReportFilters();
      }
    },
    searchReport() {
      this.pagination.filters = this.filters;
      this.getReportQuotationList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
.table-overflow {
  min-height: 20vh;
}
</style>
